// extracted by mini-css-extract-plugin
export default {"main":"_7bbd03cda7 _48ad517d0e","xmark":"e7196c0f35","fl_img":"_12b2a9f733 _5d1b11dd9d"};